<form class="flex items-center pr-2 max-w-52 w-full">   
    <label for="simple-search" class="sr-only">Search</label>
    <div class="relative w-full">
        <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
            <svg class="w-[15px] h-auto text-[#96A0B5]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
            </svg>
        </div>
        <input 
            type="text" 
            id="simple-search" 
            name="search"
            class="bg-[#FFFFFF] border border-[#DBE0E6] text-black text-[13px] rounded-[6px] py-1  block w-full ps-9 p-[3px] placeholder:text-[#96A0B5] focus:outline-none focus:shadow focus:shadow-[#C7B1FF] focus:ring-[0.5px] focus:ring-[#C7B1FF]" 
            placeholder="Search" 
            [(ngModel)]="searchValue"
            (ngModelChange)="onInputChange($event)"
        />
    </div>    
</form>
